import React, { useState, useEffect, useRef } from "react";
import "./style.scss";
import { segmentData } from "./helper";
import HeaderSegment from "./Components/HeaderSegment";
import LeftPanel from "./Components/LeftPanel";
import ChatConsole from "./Components/ChatConsole";
import {
  collection,
  query,
  orderBy,
  onSnapshot,
  limit,
  addDoc,
  serverTimestamp,
  where,
  setDoc,
  doc,
} from "firebase/firestore";
import { db, rtdb } from "../../firebase/firebaseChat";
import { useLocation } from "react-router-dom";
import { getUser, retrieveToken } from "utils/storage";
import { useChatThreads } from "hooks/api/useChatThreads";
import { ref, onDisconnect, set } from "firebase/database";
function Chats() {
  const location = useLocation();
  const profileId = location.state?.profileId;
  const chatId = location.state?.chatId;
  const [searchTerm, setSearchTerm] = useState("");

  const [segment, setSegment] = useState("all");
  const [userChats, setUserChats] = useState([]);
  const [selectedThread, setSelectedThread] = useState(null);

  // console.log(selectedThread, "selectedThread");

  const [messages, setMessages] = useState([]);
  const user = JSON.parse(retrieveToken("user") || "{}");
  const currentUserId = user?.aec_id;
  const sorted = [currentUserId, profileId].sort();
  const generatedChatId = `${sorted[0]}_${sorted[1]}`;
  const [selectedChatId, setSelectedChatId] = useState(generatedChatId);

  // ✅ ONLINE / OFFLINE STATUS (Quota-safe)

  useEffect(() => {
    if (!currentUserId) return;

    const statusRef = ref(rtdb, `/status/${currentUserId}`);

    // console.log("🟡 #1 Setting ONLINE:", currentUserId);

    set(statusRef, {
      online: true,
      lastChanged: Date.now(),
    })
      .then(() => console.log("✅  #1 ONLINE written to RTDB"))
      .catch((err) => console.error("❌ #1 RTDB error", err));

    onDisconnect(statusRef).set({
      online: false,
      lastChanged: Date.now(),
    });
  }, [currentUserId]);

  // console.log(selectedChatId, "currentUserId");

  const lastSnapshotRef = useRef(null);

  // 🔥 Fetch chat threads from API
  const { data, isLoading, error, refetch } = useChatThreads({
    search: searchTerm || "",
    type: segment === "unread" ? 1 : segment === "favourite" ? 2 : "",
    page: 1,
    limit: 50,
  });

  const getUserData = getUser().aec_id;

  // console.log(`${getUserData}`, "data");

  const chatList = data?.chat_data || [];

  useEffect(() => {
    if (!currentUserId) return;

    const q = query(
      collection(db, "chats"),
      where("users", "array-contains", currentUserId)
    );

    const unsubscribe = onSnapshot(q, async (snapshot) => {
      lastSnapshotRef.current = snapshot;

      const chats = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setUserChats(chats);
    });

    return () => {
      if (selectedChatId) {
        const chatRef = doc(db, "chats", selectedChatId);
        setDoc(
          chatRef,
          {
            lastSeen: { [currentUserId]: serverTimestamp() },
          },
          { merge: true }
        );
      }

      unsubscribe();
    };
  }, [currentUserId, selectedChatId]);

  // useEffect(() => {
  //   if (!currentUserId) return;

  //   const q = query(
  //     collection(db, "chats"),
  //     where("users", "array-contains", currentUserId)
  //   );

  //   const unsubscribe = onSnapshot(q, (snapshot) => {
  //     const chats = snapshot.docs.map((doc) => ({
  //       id: doc.id,
  //       ...doc.data(),
  //     }));

  //     const uniqueChats = [];

  //     const seen = new Set();

  //     for (const chat of chats) {
  //       if (!seen.has(chat.chatId)) {
  //         uniqueChats.push(chat);
  //         seen.add(chat.chatId);
  //       }
  //     }

  //     setUserChats(uniqueChats);

  //     // 🔥 ALSO refresh backend threads list
  //     refetch();
  //   });

  //   return () => unsubscribe();
  // }, [currentUserId, refetch]);

  // console.log(selectedChatId);

  useEffect(() => {
    if (!selectedChatId) return;

    const chatRef = collection(db, "chats", selectedChatId, "messages");
    const q = query(chatRef, orderBy("timestamp", "asc"), limit(50));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const fetchedMessages = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setMessages(fetchedMessages);
    });

    return () => unsubscribe();
  }, [selectedChatId]);

  const handleSendMessage = async (text) => {
    if (!text.trim()) return;

    let chatId = selectedChatId;
    let receiverId = profileId;

    if (!chatId && receiverId) {
      const sorted = [currentUserId, profileId].sort();
      const generatedChatId = `${sorted[0]}_${sorted[1]}`;

      const participants = {
        [currentUserId]: {
          name: user?.full_name || user?.name || "You",
          image:
            user?.profile_image ||
            user?.image ||
            "https://cdn-icons-png.flaticon.com/512/149/149071.png",
        },
        [receiverId]: {
          name: "Receiver",
          image: "",
        },
      };

      const newChatData = {
        chatId: generatedChatId,
        users: [currentUserId, receiverId],
        participants,
        typingStatus: {
          [currentUserId]: false,
          [receiverId]: false,
        },
        onlineStatus: {
          [currentUserId]: false,
          [receiverId]: false,
        },
        unreadMessageCount: {
          [currentUserId]: 0,
          [receiverId]: 0,
        },
        lastMessage: text.trim(),
        lastMessageSender: currentUserId,
        lastMessageType: "",
        lastMessageTime: serverTimestamp(),
        isActive: true,
        createdAt: serverTimestamp(),
        userSettings: {
          [currentUserId]: {
            muted: false,
            pinned: false,
            favorite: false,
            blocked: false,
          },
          [receiverId]: {
            muted: false,
            pinned: false,
            favorite: false,
            blocked: false,
          },
        },
      };

      const chatRef = collection(db, "chats");
      const newChatRef = await addDoc(chatRef, newChatData);

      chatId = newChatRef.chatId;
      setSelectedChatId(chatId);
    }

    const chatRef = collection(db, "chats", chatId, "messages");

    await addDoc(chatRef, {
      senderId: currentUserId,
      receiverId: receiverId,
      lastMessage: text.trim(),

      text: text.trim(),
      type: "text",
      status: "unread",
      timestamp: serverTimestamp(),
    });

    const chatDocRef = doc(db, "chats", chatId);
    await setDoc(
      chatDocRef,
      {
        lastMessage: text.trim(),
        lastMessageSender: currentUserId,
        lastMessageType: "text",
        lastMessageTime: serverTimestamp(),
      },
      { merge: true }
    );
  };

  // console.log(userChats, "userChats");

  useEffect(() => {
    if (!selectedChatId || !currentUserId) return;

    const chat = userChats.find((c) => c.chatId === selectedChatId);
    if ((chat?.unreadMessageCount?.[currentUserId] || 0) > 0) {
      const chatDocRef = doc(db, "chats", selectedChatId);
      setDoc(
        chatDocRef,
        {
          unreadMessageCount: {
            [currentUserId]: 0,
          },
        },
        { merge: true }
      );
    }
  }, [selectedChatId, userChats]);

  // console.log(selectedChatId, "selectedChatId");

  // console.log(messages, "messages");
  const handleMobileBack = () => {
    setSelectedThread(null);
    setSelectedChatId(null);
  };

  return (
    <div className="container chat-container">
      <h1 className="chat-heading">Chats</h1>

      <HeaderSegment
        data={segmentData}
        onChange={(value) => {
          setSegment(value);
          setSelectedChatId(null);
        }}
        selectedThread={selectedThread}
      />

      <div className="chat-section">
        <div className="left-section">
          <LeftPanel
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            listType={segment}
            currentUserId={currentUserId}
            selectedChatId={selectedChatId}
            setSelectedThread={setSelectedThread}
            selectedThread={selectedThread}
            userChats={data}
            segment={segment}
            setSelectedChatId={setSelectedChatId}
            isLoading={isLoading}
          />
        </div>

        {selectedThread && (
          <div className="right-section">
            <ChatConsole
              setSelectedThread={setSelectedThread}
              userChats={userChats}
              selectedThread={selectedThread}
              selectedChatId={selectedChatId}
              messages={messages}
              currentUserId={currentUserId}
              onSendMessage={handleSendMessage}
              isNewChat={!selectedChatId && profileId}
              onBack={handleMobileBack}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default Chats;
